<template>
    <section class="innerpages animate__animated animate__slideInRight">
       <div class="container ">
          <div class="row">
             <div class="col-md-12">
                <div class="filterTabs">
                   <!-- List group -->
                   <ul class="nav nav-pills nav-fill" id="myList" role="tablist">
                      <li class="nav-item" v-for="tab in tabs">
                         <a  class="nav-link" :class="{active : tab.key === activeTab}" data-toggle="tab" @click="openTab(tab)" role="tab">{{tab.label}}</a>
                      </li>
                   </ul>
                   <!-- Tab panes -->
                   <div class="tab-content">
                      <div v-for="(tab, key) in tabs" class="tab-pane animate__animated animate__slideInRight" :class="{active : tab.key === activeTab}" :id="tab.key" role="tabpanel">
                         <div class="show-filter" v-if="tab.showPicker">
                            <div class="row">
                               <div class="col-5 pr-2">
                                  <div class="filterWrapper">
                                     <input type="text" class="form-control " placeholder="Start Date"  id="stDatePicker" />
                                     <svg xmlns="http://www.w3.org/2000/svg" width="10.377" height="10.371" viewBox="0 0 10.377 10.371">
                                        <g transform="translate(0 -1.991)">
                                           <g transform="translate(0 8.665)">
                                              <path class="a" d="M1.192,353.28,0,356.976l3.7-1.192Z" transform="translate(0 -353.28)"/>
                                           </g>
                                           <g transform="translate(2.03 1.991)">
                                              <g transform="translate(0 0)">
                                                 <rect class="a" width="8.227" height="3.577" transform="translate(0 5.817) rotate(-45)"/>
                                              </g>
                                           </g>
                                           <g transform="translate(7.144 1.998)">
                                              <path class="a" d="M376.8,1.848,375.131.179a.576.576,0,0,0-.835,0l-.537.537,2.5,2.5.537-.537A.576.576,0,0,0,376.8,1.848Z" transform="translate(-373.76 0)"/>
                                           </g>
                                        </g>
                                     </svg>
                                  </div>
                               </div>
                               <div class="col-5 pl-2 ">
                                  <div class="filterWrapper">
                                     <input type="text" class="form-control" placeholder="End Date" id="endDatePicker"/>
                                     <svg xmlns="http://www.w3.org/2000/svg" width="10.377" height="10.371" viewBox="0 0 10.377 10.371">
                                        <g transform="translate(0 -1.991)">
                                           <g transform="translate(0 8.665)">
                                              <path class="a" d="M1.192,353.28,0,356.976l3.7-1.192Z" transform="translate(0 -353.28)"/>
                                           </g>
                                           <g transform="translate(2.03 1.991)">
                                              <g transform="translate(0 0)">
                                                 <rect class="a" width="8.227" height="3.577" transform="translate(0 5.817) rotate(-45)"/>
                                              </g>
                                           </g>
                                           <g transform="translate(7.144 1.998)">
                                              <path class="a" d="M376.8,1.848,375.131.179a.576.576,0,0,0-.835,0l-.537.537,2.5,2.5.537-.537A.576.576,0,0,0,376.8,1.848Z" transform="translate(-373.76 0)"/>
                                           </g>
                                        </g>
                                     </svg>
                                  </div>
                               </div>
                               <div class="col-2 pl-0 pr-0">
                                  <div class="filterWrapper">
                                     <button class="btn btn-outline btnFilter" @click="loadTabData">Apply</button>
                                  </div>
                               </div>
                            </div>
                         </div>
  
                       
                         <div class="card">
                             <b-table
                               :items="masterData"
                               :fields="fields"
                               :sort-by.sync="sortBy"
                               :sort-desc.sync="sortDesc"
                               sort-icon-right
                               responsive="sm"
                               show-empty
                               @row-clicked="openDetails"
                               tbody-tr-class="dataDivider"
                               >
                               <template v-slot:empty="scope">
                                 <h5 class="noData">No Data</h5>
                               </template>
                               <template v-slot:cell(total)="data">
                                 <i style="font-style:normal">{{ data.value }} 
                                    <span class="icon-arrow">
                                     <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 407.436 407.436" style="enable-background:new 0 0 407.436 407.436;" xml:space="preserve">
                                        <polygon points="112.814,0 91.566,21.178 273.512,203.718 91.566,386.258 112.814,407.436 315.869,203.718 "></polygon>
                                     </svg>
                                  </span>
                                  </i>
                               </template>
                             </b-table>
  
                         </div>
                      </div>
                   </div>
                </div>
             </div>
          </div>
       </div>
    </section>
  </template>
  <script>
  import Rolldate from 'rolldate';
  import {DEFAULT_SOURCCE_ID} from '../main.js'
  export default {
   data(){
     return {
       tabs: [
         {label: "Today", key: "today", start: 0, end: 0},
         {label: "Yesterday", key: "yesterday", start: 1, end: 1},
         {label: "30 Days", key: "thirtyD", start: 30, end: 0},
         {label: "Custom", key: "custom", showPicker: true}
       ],
       sortBy: 'total',
       sortDesc: true,
       fields: [
          { key: 'project_name', label: "Project", 'class': 'headingClassQualification'},
          { key: 'enquiry_source_name', label: "Source"},
          { key: 'total', label: "Count"},
       ],
       masterData: []
     }
   },
   created(){
     this.loadTabData();
     this.$store.dispatch('setActiveTitle', "Qualification Report");
     this.tabDefaults.searchFn = this.loadTabData;
   },
   mounted(){
     this.initRollDate()
   },
   methods: {
     initRollDate(){
       let vm = this;
       let srd = new Rolldate({
         el: '#stDatePicker',
         format: 'DD-MM-YYYY',
         beginYear: 2012,
         endYear: vm.$moment().year(),
         confirm: vm.logStartInput,
         value: this.$moment().subtract(this.tabDefaults.rSt,'d').format('YYYY-MM-DD'),
         lang: { 
             title: ' ',
             cancel: 'Cancel', 
             confirm: 'Done',
             year: '',
             month: '',
             day: ''
         }});
       let erd = new Rolldate({
         el: '#endDatePicker',
         format: 'DD-MM-YYYY',
         beginYear: 2012,
         endYear: vm.$moment().year(),
         confirm: vm.logEndInput,
         value: this.$moment().subtract(this.tabDefaults.rEnd,'d').format('YYYY-MM-DD'),
         lang: { 
             title: ' ', 
             cancel: 'Cancel', 
             confirm: 'Done',
             year: '',
             month: '',
             day: ''
         }});
     },
     openTab(tab){
       this.tabDefaults.tab = tab.key
       this.loadTabData();
     },
     logStartInput(date){
       let diff = this.$moment().diff(this.$moment(date, 'DD-MM-YYYY'), 'days')
       this.tabDefaults.rSt = diff
     },
     logEndInput(date){
       let diff = this.$moment().diff(this.$moment(date, 'DD-MM-YYYY'), 'days')
       this.tabDefaults.rEnd = diff
     },
     openDetails(qualification){
       let activeItem = {label: qualification.enquiry_source_name,project_id: qualification.project_id, labelNo:2, itemType: "qualification", itemId: qualification.enquiry_source_id, data: qualification.data}
       this.$store.dispatch('setActiveItem', activeItem);
       this.$router.push("/statusdetails");
     },
     loadTabData(){
       let dateTo = this.defaultEndDate.format('YYYY-MM-DD');
       let dateFrom = this.defaultStartDate.format('YYYY-MM-DD');
       this.$store.dispatch('setDefaultDates', {from: dateFrom, upto: dateTo});
       let sourceIds = this.$store.getters.selectedSources.join(',')
       let projectIds = this.$store.getters.selectedProjectIds.join(',')
       let managerId = this.$store.getters.selectedManager || ''
       let executive = this.$store.getters.executive || ''
       let substatus = this.$store.getters.substatus.join(',')
       let status = this.$store.getters.status.join(',')
       let searchDataUrl = new URLSearchParams({start_date: dateFrom, end_date: dateTo, manager_id: managerId, source_ids: sourceIds, project_ids: projectIds, executive_type: executive, lead_sub_statuses: substatus, lead_statuses: status}).toString();
       let url = `/qualification?${searchDataUrl}`
       this.$axios.get(url)
         .then(res => {
           if(res){
            this.masterData = res.data;
           }
         })
         .catch((err) => {
          if (err.response.status === 500) {
            swal({
              title: "Server Error!",
              icon: "error",
            });
          } else {
            swal({
              title: "Error",
              text: err.response.data.message,
              icon: "error",
            });
          }
        });
     }
   },
   computed: {
     activeTabHash(){
       let ah = this.tabs.find(el => el.key === this.activeTab)
       if(ah.key === "custom"){
         ah.start = this.tabDefaults.rSt
         ah.end = this.tabDefaults.rEnd
       }
       return ah
     },
     sSources(){
        return this.$store.getters.selectedSources;
      },
     defaultStartDate(){
       return this.$moment().subtract(this.activeTabHash.start,'d')
     },
     defaultEndDate(){
       return this.$moment().subtract(this.activeTabHash.end,'d')
     },
     activeTab(){
       return this.tabDefaults.tab;
     },
     tabDefaults(){
       return this.$store.getters.sDefaults;
     }
   }
  }
  </script>